module.exports = function (url, currentBasePath) {
    if(!url) {
        return '';
    }

    let basePath = currentBasePath.replace(/\/+$/, '');
    return url.replace(basePath, '');
}